package app.dashboard

import app.credit.creditItem
import app.credit.statusValues
import app.layouts.adminMenu
import app.properties.*
import app.settings.backendPath
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onClickFunction
import org.w3c.dom.get
import react.*
import react.dom.*
import kotlin.browser.localStorage
import kotlin.js.Math
import kotlin.math.ceil

interface DashboardState : RState {
    var creditList: ArrayList<Credit>?
    var time: Int
    var page: Int
    var count: Int
    var filters: HashMap<String,String>
    var regionList: Array<Region>?
}

class Dashboard : RComponent<RProps, DashboardState>() {

    init {

        chackLogin()

        state.time = 0
        state.page = 1
        state.count = 0
        state.filters = hashMapOf()
        state.creditList = arrayListOf()

        getCreditByPage()

        axiosGet(backendPath + "/getParameters").then {
            setState {
                regionList = it.data.region
            }
        }

    }

    fun getCreditByPage(activePage: Int = 1) {

        val obj = if(state.filters["isFiltred"] != "true") {
            object {
                val page: Int = activePage
            }
        } else {
            object {
                val page: Int = activePage
                val firstName: String = state.filters["firstName"] ?: ""
                val lastName: String = state.filters["lastName"] ?: ""
                val region: String = state.filters["region"] ?: ""
                val status: String = state.filters["status"] ?: ""
                val isFiltred: String = state.filters["isFiltred"] ?: ""
                val from: String = state.filters["from"] ?: ""
                val to: String = state.filters["to"] ?: ""
            }
        }

        axiosPost(backendPath + "/credit/list", obj).then { credit ->

            val cList = arrayListOf<Credit>()
            val creditCount = credit.data.count as Int

            credit.data.credits.forEach { it ->

                val credit = Credit()

                val documents = mutableListOf<Document>()

                it.document.forEach { document ->
                    documents.add(Document(
                            id = document.id,
                            documentType = document.documentType,
                            documentNumber = document.documentNumber,
                            docuemntGiveTime = document.docuemntGiveTime,
                            whoGiveDocument = document.whoGiveDocument
                    ))
                }

                credit.company = if (it.company != null) {
                    Company(it.company.id,
                            it.company.name,
                            it.company.hhvh,
                            it.company.address,
                            it.company.workingTime,
                            it.company.createDate,
                            it.company.staffCount,
                            CompanyType(it.company.companyType?.id, it.company.companyType?.name),
                            CompanyDirector(
                                    it.company.companyDirector.firstname,
                                    it.company.companyDirector.lastname,
                                    it.company.companyDirector.parentName),
                            it.company.birthDay)
                } else {
                    null
                }
                credit.creditType = it.creditType
                credit.currency = it.currency
                credit.document = documents
                credit.hh = it.hh

                val guarantyList = mutableListOf<String>()

                it.guaranty.forEach { guarantyName ->
                    guarantyList.add("$guarantyName")
                }

                credit.guaranty = guarantyList
                credit.person = if (it.person != null) {
                    Person(
                            it.person.id,
                            it.person.firstName,
                            it.person.lastName,
                            it.person.parentName,
                            it.person.address,
                            it.person.birthDay,
                            it.person.familyType,
                            it.person.familyPersonCount,
                            it.person.education,
                            Region(it.person?.region?.id, it.person?.region?.name),
                            it.person.area
                    )
                } else
                    null
                credit.agreeWithAcra = it.agreeWithAcra
                credit.dataRight = it.dataRight
                credit.id = it.id
                credit.loanAmount = it.loanAmount
                credit.loanTime = it.loanTime
                credit.other = it.other
                credit.paymentPerMonth = it.paymentPerMonth
                credit.cdate = it.cdate
                credit.email = it.email
                credit.hch = it.hch
                credit.status = it.status

                val phoneList = mutableListOf<String>()

                it.phones.forEach { phone ->
                    phoneList.add("$phone")
                }

                credit.phones = phoneList


                cList.add(credit)
            }
            setState {
                creditList = cList
                count = creditCount
                page = activePage
            }
        }
    }

    override fun RBuilder.render() {

        if (localStorage["jwt"] != null) {
            adminMenu()

            div("adminListBlock") {
                div("row") {
                    div("col-1") {
                        b { +"Հ․Հ" }
                    }
                    div("col") {
                        div("row") {
                            div("col") {
                                b { +"Անուն" }
                                div {
                                    input(classes = "form-control") {
                                        attrs.value = state.filters["firstName"] ?: ""
                                        attrs.onChangeFunction = {
                                            val name = getTargetValue(it)
                                            setState {
                                                state.filters["firstName"] = name
                                            }
                                        }
                                    }
                                }
                            }
                            div("col") {
                                b { +"Ազգանուն" }
                                div {
                                    input(classes = "form-control") {
                                        attrs.value = state.filters["lastName"] ?: ""
                                        attrs.onChangeFunction = {
                                            val lastName = getTargetValue(it)
                                            setState {
                                                state.filters["lastName"] = lastName
                                            }
                                        }
                                    }
                                }
                            }
                            div("col") {
                                b { +"Կարգավիճակ" }
                                div {
                                    select("form-control") {

                                        attrs["value"] = state.filters["status"] ?: ""

                                        attrs.onChangeFunction = {
                                            val value = getTargetValue(it)
                                            setState {
                                                state.filters["status"] = value
                                            }
                                        }
                                        option {
                                            attrs.value = ""
                                            +"Ընտրել կարգավիճակը"
                                        }
                                        statusValues.forEach {
                                            option {
                                                attrs.value = it
                                                +it
                                            }
                                        }
                                    }
                                }
                            }
                            div("col") {
                                b { +"Մարզը" }
                                div {
                                    select("form-control") {

                                        attrs["value"] = state.filters["region"] ?: ""

                                        attrs.onChangeFunction = {
                                            val value = getTargetValue(it)
                                            setState {
                                                state.filters["region"] = value
                                            }
                                        }
                                        option { +"Ընտրել մարզը" }
                                        state.regionList?.forEachIndexed { index, region ->
                                            option {
                                                attrs.value = region.name
                                                +region.name
                                            }
                                        }
                                    }
                                }
                            }
                            div("col") {
                                b { +"Ամսաթիվը" }
                                div {
                                    input(classes = "form-control") {
                                        attrs.value = state.filters["from"] ?: ""
                                        attrs.placeholder = "dd/mm/YYYY"
                                        attrs.onChangeFunction = {
                                            val from = getTargetValue(it)
                                            setState {
                                                state.filters["from"] = from
                                            }
                                        }
                                    }
                                }
                                div {
                                    input(classes = "form-control") {
                                        attrs.value = state.filters["to"] ?: ""
                                        attrs.placeholder = "dd/mm/YYYY"
                                        attrs.onChangeFunction = {
                                            val to = getTargetValue(it)
                                            setState {
                                                state.filters["to"] = to
                                            }
                                        }
                                    }
                                }
                            }
                            div("col") {
                                b { +"Վարկի տեսակը" }
                            }
                        }
                    }
                    div("col-1") {
                        br { }
                        i("fa fa-search") {
                            attrs.onClickFunction = {
                                setState {
                                    state.filters["isFiltred"] = "true"
                                    getCreditByPage(1)
                                }
                            }
                        }
                        i("fa fa-retweet") {
                            attrs.onClickFunction = {
                                setState {
                                    state.filters["isFiltred"] = ""
                                    state.filters["name"] = ""
                                    state.filters["region"] = ""
                                    state.filters["status"] = ""
                                    state.filters["from"] = ""
                                    state.filters["to"] = ""
                                    getCreditByPage(state.page)
                                }
                            }
                        }
                    }
                }
                hr { }
                state.creditList?.forEachIndexed { index, it ->
                    creditItem(it, index)
                }
                val maxPage = ceil(state.count.toFloat() / 50).toInt()
                if (maxPage > 1) {
                    nav {
                        ul("pagination justify-content-center") {
                            (1..maxPage).forEach { page ->
                                li("page-item ${if (state.page == page) "disabled" else ""} ") {
                                    attrs {
                                        onClickFunction = {
                                            getCreditByPage(page)
                                        }
                                    }
                                    a(classes = "page-link", href = "#") { +"$page" }
                                }
                            }
                        }
                    }
                }

            }
        }

    }
}